import { createTheme, ITheme } from 'office-ui-fabric-react';

/**
 * Interface for a prop set that supports theming
 */
export interface IThemedProp {
  theme: ITheme;
}

export const defaultDarkTheme = (): ITheme => {
  return createTheme({
    palette: {
      themePrimary: '#0078D4',
      themeLighterAlt: '#0C2031',
      themeLighter: '#D0E7F8',
      themeLight: '#043862',
      themeTertiary: '#004C87',
      themeSecondary: '#1A86D9',
      themeDarkAlt: '#1890F1',
      themeDark: '#3AA0F3',
      themeDarker: '#6CB8F6',
      neutralLighterAlt: '#202020',
      neutralLighter: '#252525',
      neutralLight: '#292929',
      neutralQuaternaryAlt: '#323232',
      neutralQuaternary: '#3B3B3B',
      neutralTertiaryAlt: '#484848',
      neutralTertiary: '#797979',
      neutralSecondary: '#B3B3B3',
      neutralPrimaryAlt: '#E1E1E1',
      neutralPrimary: '#EDEDED',
      neutralDark: '#F3F3F3',
      black: '#FFFFFF',
      white: '#141414'
    }
  }) as ITheme;
};

export const defaultLightTheme = (): ITheme => {
  return createTheme({
    palette: {
      themePrimary: '#0078D4',
      themeLighterAlt: '#F3F9FD',
      themeLighter: '#D0E7F8',
      themeLight: '#A9D3F2',
      themeTertiary: '#5CA9E5',
      themeSecondary: '#1A86D9',
      themeDarkAlt: '#006CBE',
      themeDark: '#005BA1',
      themeDarker: '#004377',
      neutralLighterAlt: '#F0F0F0',
      neutralLighter: '#EDEDED',
      neutralLight: '#E8E8E8',
      neutralQuaternaryAlt: '#E1E1E1',
      neutralQuaternary: '#D2D2D2',
      neutralTertiaryAlt: '#C8C8C8',
      neutralTertiary: '#A1A1A1',
      neutralSecondary: '#484644',
      neutralPrimaryAlt: '#8D8B8A',
      neutralPrimary: '#323130',
      neutralDark: '#605E5D',
      black: '#000000',
      white: '#FFFFFF'
    }
  }) as ITheme;
};
